import { Component, Input, OnInit } from "@angular/core";
import { Question } from "../../Models/question.interface";

@Component({
  selector: "question-title",
  templateUrl: "./question-title.component.html",
  styleUrls: ["./question-title.component.css"],
})
export class QuestionTitleComponent implements OnInit {
  @Input() question: Question;
  constructor() {}

  ngOnInit(): void {}
}
